import core from './core';
import panels from './panels';

const cad = {
  ...core,
  ...panels,
};

export default cad;
